export default __webpack_public_path__ + "img/publication/publication4_700.webp";